import PropTypes from 'prop-types'
import React from 'react'

const PlanIcon = ({
   className,
   color,
   width,
   height
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g className={className} fill={color}>
         <path
            d="M21,0H3A1,1,0,0,0,2,1V23.868L6,21.2l3,2,3-2,3,2,3-2,4,2.666V1A1,1,0,0,0,21,0ZM13,15H6V13h7Zm-1-5a3,3,0,1,1,3-3A3,3,0,0,1,12,10Zm6,5H15V13h3Z"
         />
      </g>
   </svg>
)

PlanIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   width: PropTypes.string
}

PlanIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   width: '24px'
}

export default React.memo(PlanIcon)
